import { lazy } from "react";

export const CreateProfileAsync = lazy(() => import("./CreateProfile"));
